import { Paragraph, colors, ActionModal } from 'common-components';
import { useAppTranslation } from '@hooks';
import { LoadingOutlined } from '@ant-design/icons';
import { memo } from 'react';

type DeleteModalPropsType = {
  isOpen: boolean
  isLoading?: boolean
  close: () => void
  title: string
  label: string
  onDeleteMutation: () => void
};

const DeleteModalComponent = ({
  isOpen,
  isLoading,
  close,
  title,
  label,
  onDeleteMutation,
}: DeleteModalPropsType) => {
  const { translate } = useAppTranslation();
  return (
    <>
      <ActionModal
        iconColor={colors.error600}
        iconBgColor={colors.error100}
        iconBorderColor={colors.error50}
        mask={{ closable: false }}
        open={isOpen}
        onOk={close}
        onConfirm={close}
        title={title}
        onCancel={close}
        actionButtons={[
          {
            text: translate('common.deleteModal.labelCancelButton'),
            onClick: () => {
              close();
            },
          },
          {
            text: isLoading ? (
              <LoadingOutlined />
            ) : (
              translate('common.deleteModal.labelConfirmButton')
            ),
            type: isLoading ? 'primary' : 'dangerFilled',
            disabled: isLoading,
            onClick: async () => {
              await onDeleteMutation();
              isOpen = !isOpen;
              close();
            },
          },
        ]}
      >
        <Paragraph size="md">{label}</Paragraph>
      </ActionModal>
    </>
  );
};

const DeleteModal = memo(
  DeleteModalComponent,
  (oldProps: DeleteModalPropsType, newProps: DeleteModalPropsType) => {
    return JSON.stringify(oldProps) === JSON.stringify(newProps);
  },
);

export default DeleteModal;
